import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faLockOpen } from "@fortawesome/pro-solid-svg-icons/faLockOpen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcText } from "components/MprcText";
import * as React from "react";

interface IProps {
    locked: boolean;
    unlockedColor?: MprcColors;
    lockedColor?: MprcColors;
}

export const IconLock: React.FC<IProps> = ({ locked, unlockedColor = "success", lockedColor = "error" }) => {
    return <MprcText color={locked ? lockedColor : unlockedColor}><FontAwesomeIcon icon={locked ? faLock : faLockOpen} fixedWidth /></MprcText>;
};
